import type React from "react"
import { useId } from "react"
import { useTranslation } from "react-i18next"

import { FormLabel, Stack } from "@mui/material"
import ToggleButton from "@mui/material/ToggleButton"
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup"

export const INTERVAL_CHART_SERIES_BY = ["meter", "source"] as const
export type IntervalChartSeriesBy = (typeof INTERVAL_CHART_SERIES_BY)[number]

interface IntervalDataChartSeriesByProps {
  onSeriesByChange: (nextSeriesBy: IntervalChartSeriesBy) => void
  seriesBy: IntervalChartSeriesBy
}

export const IntervalDataChartSeriesBy: React.FC<
  IntervalDataChartSeriesByProps
> = ({ onSeriesByChange, seriesBy }) => {
  const { t } = useTranslation("sites")
  const labelId = useId()

  const handleSeriesByChange = (
    _event: React.MouseEvent<HTMLElement>,
    nextSeriesBy: IntervalChartSeriesBy | null
  ) => {
    if (!nextSeriesBy) {
      return
    }
    onSeriesByChange(nextSeriesBy)
  }

  return (
    <Stack spacing={0.5}>
      <FormLabel id={labelId} sx={{ typography: "caption" }}>
        {t("intervalData.seriesBy.label")}
      </FormLabel>
      <ToggleButtonGroup
        aria-labelledby={labelId}
        exclusive
        onChange={handleSeriesByChange}
        size="small"
        value={seriesBy}
      >
        <ToggleButton value="meter">
          {t("intervalData.seriesBy.meterCode")}
        </ToggleButton>
        <ToggleButton value="source">
          {t("intervalData.seriesBy.source")}
        </ToggleButton>
      </ToggleButtonGroup>
    </Stack>
  )
}
